import { CustomType, GoalWithProgress, ProgressType } from './api.types'
import { msgid, ngettext, t } from 'ttag'
import {
  capitalizeFirstLetter,
  getLocalizedCountUnit,
  getLocalizedDisplayUnit,
  unitsCountDurationMinuteLong,
  unitsCountDurationMinuteShort,
  unitsCountEnergyCalorieLong,
  unitsCountPointsShort,
  unitsDisplayDurationCalorieLong,
  unitsDisplayPointsShort,
} from '../common/helpers/units'
import { isCustomType } from '../common/helpers/challenges'
import { PointsLogic } from '../views/ChallengeAdmin/components/ChallengePoints/ChallengePoints'
import React from 'react'

export enum CustomTypeCategory {
  CYCLING = 'CYCLING',
  DISTANCE = 'DISTANCE',
  EXERCISE = 'EXERCISE',
  MINDFULNESS = 'MINDFULNESS',
  OUTDOOR_TIME = 'OUTDOOR_TIME',
  PLANKING = 'PLANKING',
  RUNNING = 'RUNNING',
  SLEEP = 'SLEEP',
  SWIMMING = 'SWIMMING',
  WALKING = 'WALKING',
  WATER_DRINKING = 'WATER_DRINKING',
  YOGA = 'YOGA',
  STEPS = 'STEPS',
  CALORIES = 'CALORIES',
  INTENSIVE_MINUTES = 'INTENSIVE_MINUTES',
  POINTS = 'POINTS',
  OTHER_MIN = 'OTHER_MIN',

  CUSTOM = 'CUSTOM',
  CUSTOM_SIMPLE = 'CUSTOM_SIMPLE',
  CUSTOM_WITH_AMOUNT = 'CUSTOM_WITH_AMOUNT',

  // In use but should be deprecated and replaced with ACTIVITY_INDEX.
  ALL = 'ALL',
  // Not in use yet.
  ACTIVITY_INDEX = 'ACTIVITY_INDEX',

  // New manual entry challenges.
  BOOK_READING = 'BOOK_READING',
  ENCOURAGING = 'ENCOURAGING',
  CAR_FREE_DAYS = 'CAR_FREE_DAYS',
  ALCOHOL_ABSTINENCE = 'ALCOHOL_ABSTINENCE',
  SQUATTING = 'SQUATTING',
  CONTRAST_SHOWER = 'CONTRAST_SHOWER',
  FINANCE_TRACKING = 'FINANCE_TRACKING',
  HEALTHY_COOKING = 'HEALTHY_COOKING',
  DEEP_BREATHING = 'DEEP_BREATHING',
  DAILY_JOURNALING = 'DAILY_JOURNALING',
  PUSH_UPS = 'PUSH_UPS',
  PULL_UPS = 'PULL_UPS',
  CREATIVE_ARTS = 'CREATIVE_ARTS',
  SOCIALIZING_WITH_FRIENDS = 'SOCIALIZING_WITH_FRIENDS',
  COLD_PLUNGE = 'COLD_PLUNGE',
  INTERMITTENT_FASTING = 'INTERMITTENT_FASTING',
  GRATITUDE_JOURNALING = 'GRATITUDE_JOURNALING',
  LANGUAGE_LEARNING = 'LANGUAGE_LEARNING',
  HOBBY_DEVELOPMENT = 'HOBBY_DEVELOPMENT',
  NATURAL_LIGHT_EXPOSURE = 'NATURAL_LIGHT_EXPOSURE',
  SMOKING_CESSATION = 'SMOKING_CESSATION',
  PHONE_FREE_TIME = 'PHONE_FREE_TIME',
  //CAFFEINE_REDUCTION = 'CAFFEINE_REDUCTION',
  SCREEN_FREE_MEALS = 'SCREEN_FREE_MEALS',
  DAILY_FLOSSING = 'DAILY_FLOSSING',
  //STRESS_LEVEL_MONITORING = 'STRESS_LEVEL_MONITORING',
  //MOOD_TRACKING = 'MOOD_TRACKING',
}

export const customTypes = [
  {
    id: CustomTypeCategory.STEPS,
    text: t`Steps`,
  },
  {
    id: CustomTypeCategory.INTENSIVE_MINUTES,
    text: t`Intensive minutes`,
  },
  {
    id: CustomTypeCategory.CALORIES,
    text: unitsDisplayDurationCalorieLong,
  },
  {
    id: CustomTypeCategory.CYCLING,
    text: t`Cycling`,
  },
  {
    id: CustomTypeCategory.DISTANCE,
    text: t`Distance`,
  },
  {
    id: CustomTypeCategory.EXERCISE,
    text: t`Exercise minutes`,
  },
  {
    id: CustomTypeCategory.OTHER_MIN,
    text: t`Other exercise minutes`,
  },
  {
    id: CustomTypeCategory.MINDFULNESS,
    text: t`Mindfulness`,
  },
  {
    id: CustomTypeCategory.OUTDOOR_TIME,
    text: t`Outdoor time`,
  },
  {
    id: CustomTypeCategory.PLANKING,
    text: t`Planking`,
  },
  {
    id: CustomTypeCategory.RUNNING,
    text: t`Running`,
  },
  {
    id: CustomTypeCategory.SLEEP,
    text: t`Sleep`,
  },
  {
    id: CustomTypeCategory.SWIMMING,
    text: t`Swimming`,
  },
  {
    id: CustomTypeCategory.WALKING,
    text: t`Walking`,
  },
  {
    id: CustomTypeCategory.WATER_DRINKING,
    text: t`Water drinking`,
  },
  {
    id: CustomTypeCategory.YOGA,
    text: t`Yoga`,
  },
  {
    id: CustomTypeCategory.POINTS,
    text: t`Wellness points`,
  },
  // New manual entry challenges.
  // Book reading
  {
    id: CustomTypeCategory.BOOK_READING,
    text: t`Book reading`,
  },
  // Encouraging someone
  {
    id: CustomTypeCategory.ENCOURAGING,
    text: t`Encouraging someone`,
  },
  // Car-free days
  {
    id: CustomTypeCategory.CAR_FREE_DAYS,
    text: t`Car-free days`,
  },
  // Alcohol abstinence
  {
    id: CustomTypeCategory.ALCOHOL_ABSTINENCE,
    text: t`Alcohol abstinence`,
  },
  // Squatting
  {
    id: CustomTypeCategory.SQUATTING,
    text: t`Squatting`,
  },
  // Contrast shower
  {
    id: CustomTypeCategory.CONTRAST_SHOWER,
    text: t`Contrast shower`,
  },
  // Finance tracking
  {
    id: CustomTypeCategory.FINANCE_TRACKING,
    text: t`Finance tracking`,
  },
  // Healthy cooking
  {
    id: CustomTypeCategory.HEALTHY_COOKING,
    text: t`Healthy cooking`,
  },
  // Deep breathing
  {
    id: CustomTypeCategory.DEEP_BREATHING,
    text: t`Deep breathing`,
  },
  // Daily Journaling
  {
    id: CustomTypeCategory.DAILY_JOURNALING,
    text: t`Daily journaling`,
  },
  // Push-Ups
  {
    id: CustomTypeCategory.PUSH_UPS,
    text: t`Push-ups`,
  },
  // Pull-Ups
  {
    id: CustomTypeCategory.PULL_UPS,
    text: t`Pull-ups`,
  },
  // Creative Arts
  {
    id: CustomTypeCategory.CREATIVE_ARTS,
    text: t`Creative arts`,
  },
  // Socializing with Friends
  {
    id: CustomTypeCategory.SOCIALIZING_WITH_FRIENDS,
    text: t`Socializing with friends`,
  },
  // Cold Plunge
  {
    id: CustomTypeCategory.COLD_PLUNGE,
    text: t`Cold plunge`,
  },
  // Intermittent Fasting
  {
    id: CustomTypeCategory.INTERMITTENT_FASTING,
    text: t`Intermittent fasting`,
  },
  // Gratitude Journaling
  {
    id: CustomTypeCategory.GRATITUDE_JOURNALING,
    text: t`Gratitude journaling`,
  },
  // Language learning
  {
    id: CustomTypeCategory.LANGUAGE_LEARNING,
    text: t`Language learning`,
  },
  // Hobby Development
  {
    id: CustomTypeCategory.HOBBY_DEVELOPMENT,
    text: t`Hobby development`,
  },
  // Natural Light Exposure
  {
    id: CustomTypeCategory.NATURAL_LIGHT_EXPOSURE,
    text: t`Natural light exposure`,
  },
  // Smoking Cessation
  {
    id: CustomTypeCategory.SMOKING_CESSATION,
    text: t`Smoking cessation`,
  },
  // Phone-Free Time
  {
    id: CustomTypeCategory.PHONE_FREE_TIME,
    text: t`Phone-free time`,
  },
  // Caffeine Reduction
  /*{
    id: CustomTypeCategory.CAFFEINE_REDUCTION,
    text: t`Caffeine reduction`,
  },*/
  // Screen-Free Meals
  {
    id: CustomTypeCategory.SCREEN_FREE_MEALS,
    text: t`Screen-free meals`,
  },
  // Daily Flossing
  {
    id: CustomTypeCategory.DAILY_FLOSSING,
    text: t`Daily flossing`,
  },
  // Stress Level Monitoring
  /*{
    id: CustomTypeCategory.STRESS_LEVEL_MONITORING,
    text: t`Stress level monitoring`,
  },*/
  // Mood Tracking
  /*{
    id: CustomTypeCategory.MOOD_TRACKING,
    text: t`Mood tracking`,
  },*/
]

const daysText = ngettext(msgid`day`, `days`, 2)

export const customUnits = [
  {
    category: CustomTypeCategory.CYCLING,
    id: CustomType.CYCLING_KM,
    text: getLocalizedCountUnit('length-kilometer', 'km'),
    label: getLocalizedDisplayUnit('length-kilometer', 'Kilometers'),
  },
  {
    category: CustomTypeCategory.CYCLING,
    id: CustomType.CYCLING_MI,
    text: getLocalizedCountUnit('length-mile', 'mi'),
    label: getLocalizedDisplayUnit('length-mile', 'Miles'),
  },
  {
    category: CustomTypeCategory.CYCLING,
    id: CustomType.CYCLING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.CYCLING,
    id: CustomType.CYCLING_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.DISTANCE,
    id: CustomType.DISTANCE_KM,
    text: getLocalizedCountUnit('length-kilometer', 'km'),
    label: getLocalizedDisplayUnit('length-kilometer', 'Kilometers'),
  },
  {
    category: CustomTypeCategory.DISTANCE,
    id: CustomType.DISTANCE_MI,
    text: getLocalizedCountUnit('length-mile', 'mi'),
    label: getLocalizedDisplayUnit('length-mile', 'Miles'),
  },
  {
    category: CustomTypeCategory.EXERCISE,
    id: CustomType.EXERCISE_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.OTHER_MIN,
    id: CustomType.OTHER_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  // As we renamed "Exercise" to "Exercise minutes", we don't support hours anymore.
  /*{
    category: CustomTypeCategory.EXERCISE,
    id: CustomType.EXERCISE_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },*/
  {
    category: CustomTypeCategory.MINDFULNESS,
    id: CustomType.MINDFULNESS_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.MINDFULNESS,
    id: CustomType.MINDFULNESS_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.OUTDOOR_TIME,
    id: CustomType.OUTDOOR_TIME_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.OUTDOOR_TIME,
    id: CustomType.OUTDOOR_TIME_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.PLANKING,
    id: CustomType.PLANKING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.PLANKING,
    id: CustomType.PLANKING_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.RUNNING,
    id: CustomType.RUNNING_KM,
    text: getLocalizedCountUnit('length-kilometer', 'km'),
    label: getLocalizedDisplayUnit('length-kilometer', 'Kilometers'),
  },
  {
    category: CustomTypeCategory.RUNNING,
    id: CustomType.RUNNING_MI,
    text: getLocalizedCountUnit('length-mile', 'mi'),
    label: getLocalizedDisplayUnit('length-mile', 'Miles'),
  },
  {
    category: CustomTypeCategory.RUNNING,
    id: CustomType.RUNNING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.RUNNING,
    id: CustomType.RUNNING_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.SLEEP,
    id: CustomType.SLEEP_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.SLEEP,
    id: CustomType.SLEEP_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_M,
    text: getLocalizedCountUnit('length-meter', 'm'),
    label: getLocalizedDisplayUnit('length-meter', 'Meters'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_YD,
    text: getLocalizedCountUnit('length-yard', 'yd'),
    label: getLocalizedDisplayUnit('length-yard', 'Yards'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_KM,
    text: getLocalizedCountUnit('length-kilometer', 'km'),
    label: getLocalizedDisplayUnit('length-kilometer', 'Kilometers'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_MI,
    text: getLocalizedCountUnit('length-mile', 'mi'),
    label: getLocalizedDisplayUnit('length-mile', 'Miles'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.SWIMMING,
    id: CustomType.SWIMMING_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.WALKING,
    id: CustomType.WALKING_KM,
    text: getLocalizedCountUnit('length-kilometer', 'km'),
    label: getLocalizedDisplayUnit('length-kilometer', 'Kilometers'),
  },
  {
    category: CustomTypeCategory.WALKING,
    id: CustomType.WALKING_MI,
    text: getLocalizedCountUnit('length-mile', 'mi'),
    label: getLocalizedDisplayUnit('length-mile', 'Miles'),
  },
  {
    category: CustomTypeCategory.WALKING,
    id: CustomType.WALKING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.WALKING,
    id: CustomType.WALKING_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.WATER_DRINKING,
    id: CustomType.WATER_DRINKING_GLASS,
    text: t`glasses`,
    label: capitalizeFirstLetter(t`glasses`),
  },
  {
    category: CustomTypeCategory.WATER_DRINKING,
    id: CustomType.WATER_DRINKING_ML,
    text: getLocalizedCountUnit('volume-milliliter', 'ml'),
    label: getLocalizedDisplayUnit('volume-milliliter', 'Milliliters'),
  },
  {
    category: CustomTypeCategory.WATER_DRINKING,
    id: CustomType.WATER_DRINKING_CUP,
    text: getLocalizedCountUnit('volume-cup', 'cups', 'long'),
    label: getLocalizedDisplayUnit('volume-cup', 'Cups'),
  },
  {
    category: CustomTypeCategory.WATER_DRINKING,
    id: CustomType.WATER_DRINKING_OZ,
    text: getLocalizedCountUnit('mass-ounce', 'oz'),
    label: getLocalizedDisplayUnit('mass-ounce', 'Ounces'),
  },
  {
    category: CustomTypeCategory.YOGA,
    id: CustomType.YOGA_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.YOGA,
    id: CustomType.YOGA_HR,
    //text: getLocalizedCountUnit('duration-hour', 'h'),
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },

  {
    category: CustomTypeCategory.STEPS,
    id: CustomType.STEPS,
    text: t`steps`,
    label: t`Steps`,
  },
  {
    category: CustomTypeCategory.CALORIES,
    id: CustomType.CALORIES,
    text: unitsCountEnergyCalorieLong,
    label: unitsDisplayDurationCalorieLong,
  },
  {
    category: CustomTypeCategory.INTENSIVE_MINUTES,
    id: CustomType.INTENSIVE_MINUTES,
    // TODO: Show short?
    text: unitsCountDurationMinuteShort,
    //text: unitsCountDurationMinuteLong,
    label: t`Intensive minutes`,
  },

  {
    category: CustomTypeCategory.POINTS,
    id: CustomType.POINTS,
    text: unitsCountPointsShort,
    //text: unitsDisplayPointsShort.toLowerCase(),
    label: unitsDisplayPointsShort,
  },

  /*{
    category: CustomTypeCategory.CUSTOM_SIMPLE,
    id: CustomType.CUSTOM,
    text: 'TODO',
    label: 'TODO',
  },
  {
    category: CustomTypeCategory.CUSTOM_WITH_AMOUNT,
    id: CustomType.CUSTOM,
    text: 'TODO',
    label: 'TODO',
  },*/

  {
    category: CustomTypeCategory.BOOK_READING,
    id: CustomType.BOOK_READING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.BOOK_READING,
    id: CustomType.BOOK_READING_PAGES,
    text: t`pages`,
    label: t`Pages`,
  },
  {
    category: CustomTypeCategory.BOOK_READING,
    id: CustomType.BOOK_READING_BOOKS,
    text: t`books`,
    label: t`Books`,
  },

  {
    category: CustomTypeCategory.ENCOURAGING,
    id: CustomType.ENCOURAGING_PEOPLE,
    text: t`people`,
    label: t`Encouraging someone`,
  },
  { category: CustomTypeCategory.CAR_FREE_DAYS, id: CustomType.CAR_FREE_DAYS, text: daysText, label: t`Car free days` },
  {
    category: CustomTypeCategory.ALCOHOL_ABSTINENCE,
    id: CustomType.ALCOHOL_ABSTINENCE,
    text: daysText,
    label: t`Alcohol abstinence`,
  },
  { category: CustomTypeCategory.SQUATTING, id: CustomType.SQUATTING, text: t`squats`, label: t`Squatting` },
  {
    category: CustomTypeCategory.CONTRAST_SHOWER,
    id: CustomType.CONTRAST_SHOWER_SEC,
    text: getLocalizedCountUnit('duration-second', 'sec'),
    label: getLocalizedDisplayUnit('duration-second', 'Seconds'),
  },
  {
    category: CustomTypeCategory.FINANCE_TRACKING,
    id: CustomType.FINANCE_TRACKING,
    text: daysText,
    label: t`Finance tracking`,
  },
  {
    category: CustomTypeCategory.HEALTHY_COOKING,
    id: CustomType.HEALTHY_COOKING_MEALS,
    text: t`meals`,
    label: t`Meals`,
  },
  {
    category: CustomTypeCategory.DEEP_BREATHING,
    id: CustomType.DEEP_BREATHING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.DAILY_JOURNALING,
    id: CustomType.DAILY_JOURNALING,
    text: daysText,
    label: t`Daily journaling`,
  },
  { category: CustomTypeCategory.PUSH_UPS, id: CustomType.PUSH_UPS, text: t`push-ups`, label: t`Push-ups` },
  { category: CustomTypeCategory.PULL_UPS, id: CustomType.PULL_UPS, text: t`pull-ups`, label: t`Pull-ups` },
  {
    category: CustomTypeCategory.CREATIVE_ARTS,
    id: CustomType.CREATIVE_ARTS_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.SOCIALIZING_WITH_FRIENDS,
    id: CustomType.SOCIALIZING_WITH_FRIENDS_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.COLD_PLUNGE,
    id: CustomType.COLD_PLUNGE_SEC,
    text: getLocalizedCountUnit('duration-second', 'sec'),
    label: getLocalizedDisplayUnit('duration-second', 'Seconds'),
  },
  {
    category: CustomTypeCategory.INTERMITTENT_FASTING,
    id: CustomType.INTERMITTENT_FASTING_HR,
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  {
    category: CustomTypeCategory.GRATITUDE_JOURNALING,
    id: CustomType.GRATITUDE_JOURNALING,
    text: daysText,
    label: t`Gratitude journaling`,
  },
  {
    category: CustomTypeCategory.LANGUAGE_LEARNING,
    id: CustomType.LANGUAGE_LEARNING_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.HOBBY_DEVELOPMENT,
    id: CustomType.HOBBY_DEVELOPMENT_MIN,
    text: getLocalizedCountUnit('duration-minute', 'min'),
    label: getLocalizedDisplayUnit('duration-minute', 'Minutes'),
  },
  {
    category: CustomTypeCategory.NATURAL_LIGHT_EXPOSURE,
    id: CustomType.NATURAL_LIGHT_EXPOSURE,
    text: daysText,
    label: t`Natural light exposure`,
  },
  {
    category: CustomTypeCategory.SMOKING_CESSATION,
    id: CustomType.SMOKING_CESSATION,
    text: daysText,
    label: t`Smoking cessation`,
  },
  {
    category: CustomTypeCategory.PHONE_FREE_TIME,
    id: CustomType.PHONE_FREE_TIME_HR,
    text: getLocalizedCountUnit('duration-hour', 'hours', 'long'),
    label: getLocalizedDisplayUnit('duration-hour', 'Hours'),
  },
  /*{
    category: CustomTypeCategory.CAFFEINE_REDUCTION,
    id: CustomType.CAFFEINE_REDUCTION,
    text: daysText,
    label: t`Caffeine reduction`,
  },*/
  {
    category: CustomTypeCategory.SCREEN_FREE_MEALS,
    id: CustomType.SCREEN_FREE_MEALS,
    text: t`meals`,
    label: t`Meals`,
  },
  {
    category: CustomTypeCategory.DAILY_FLOSSING,
    id: CustomType.DAILY_FLOSSING,
    text: daysText,
    label: t`Daily flossing`,
  },
  /*{
    category: CustomTypeCategory.STRESS_LEVEL_MONITORING,
    id: CustomType.STRESS_LEVEL_MONITORING,
    text: daysText,
    label: t`Stress level monitoring`,
  },
  { category: CustomTypeCategory.MOOD_TRACKING, id: CustomType.MOOD_TRACKING, text: daysText, label: t`Mood tracking` },*/
]

export const getProgressTypeLabel = (progressType: ProgressType) => {
  switch (progressType) {
    case ProgressType.STEPS:
    case ProgressType.PERSISTENCE_STEPS:
    case ProgressType.COLLECTIVE_STEPS:
      return t`Steps`
    case ProgressType.CALORIES:
    case ProgressType.PERSISTENCE_CALORIES:
    case ProgressType.COLLECTIVE_CALORIES:
      return unitsDisplayDurationCalorieLong
    case ProgressType.INTENSIVE_MINUTES:
    case ProgressType.PERSISTENCE_INTENSIVE_MINUTES:
    case ProgressType.COLLECTIVE_INTENSIVE_MINUTES:
      return t`Intensive minutes`
    case ProgressType.ALL:
    case ProgressType.PERSISTENCE_ALL:
      return t`Activity index`
    default:
      return ''
  }
}

export const getCustomTypeCategory = (customType: CustomType | null) => {
  return customUnits.find((item) => item.id === customType)?.category
}

export const getCustomCategory = (progressType: ProgressType, customType: CustomType | null) => {
  if (customType) return getCustomTypeCategory(customType) || CustomTypeCategory.CUSTOM
  switch (progressType) {
    case ProgressType.ALL:
    case ProgressType.PERSISTENCE_ALL:
      return CustomTypeCategory.ALL
    case ProgressType.STEPS:
    case ProgressType.PERSISTENCE_STEPS:
    case ProgressType.COLLECTIVE_STEPS:
      return CustomTypeCategory.STEPS
    case ProgressType.PERSISTENCE_CALORIES:
      return CustomTypeCategory.CALORIES
    default:
    case ProgressType.INTENSIVE_MINUTES:
    case ProgressType.PERSISTENCE_INTENSIVE_MINUTES:
    case ProgressType.COLLECTIVE_INTENSIVE_MINUTES:
      return CustomTypeCategory.INTENSIVE_MINUTES
  }
}

export const getCustomTypeText = (customType?: CustomType | null, customName?: string | null) => {
  if (customType === CustomType.CUSTOM) {
    return customName
  }
  const category = customUnits.find((item) => item.id === customType)?.category
  const text = customTypes.find((item) => item.id === category)?.text
  if (!text) {
    if (customType === CustomType.STEPS) return t`Steps`
    if (customType === CustomType.CALORIES) return unitsDisplayDurationCalorieLong
    if (customType === CustomType.INTENSIVE_MINUTES) return t`Intensive minutes`
  }
  return text || customType?.toString()
}

export const getCustomTypeTextById = (id: any) => {
  const text = customTypes.find((item) => item.id === id)?.text
  if (!text) {
    if (id === ProgressType.STEPS) return t`Steps`
    if (id === ProgressType.CALORIES) return unitsDisplayDurationCalorieLong
    if (id === ProgressType.INTENSIVE_MINUTES) return t`Intensive minutes`
    if (id === ProgressType.ALL) return t`Activity index`
    if (id === ProgressType.POINTS) return t`Wellness points`
  }
  return text || id
}

export const getPointsTypeText = (activity: PointsLogic) => {
  const isCustomPointsType = [CustomTypeCategory.CUSTOM_SIMPLE, CustomTypeCategory.CUSTOM_WITH_AMOUNT].includes(
    activity.category,
  )
  return isCustomPointsType ? activity.customActivityName : getCustomTypeTextById(activity.category)
}

export const getCustomUnitTextById = (id: any) => {
  const label = customUnits.find((item) => item.id === id)?.label
  if (!label) {
    if (id === ProgressType.STEPS) return t`Steps`
    if (id === ProgressType.CALORIES) return unitsDisplayDurationCalorieLong
    if (id === ProgressType.INTENSIVE_MINUTES) return t`Intensive minutes`
    if (id === ProgressType.ALL) return t`Activity index`
    if (id === ProgressType.POINTS) return t`Wellness points`
  }
  return label || id
}

export const getCustomUnitText = (
  customType?: CustomType | null,
  customActivity?: CustomType | string | null,
  customUnit?: string | null,
) => {
  if (customActivity === CustomType.CUSTOM) {
    return customUnit
  }
  return customUnits.find((item) => item.id === customType)?.text || ''
}

export const getCustomUnitLabel = (
  customType?: CustomType | null,
  customActivity?: CustomType | string | null,
  customUnit?: string | null,
) => {
  if (customActivity === CustomType.CUSTOM) {
    return customUnit
  }
  return customUnits.find((item) => item.id === customType)?.label || ''
}

export const getUnit = (progressType: ProgressType, customType?: CustomType | null, customUnit?: string | null) => {
  let text = ''
  if (customType === CustomType.CUSTOM) {
    return customUnit
  }
  if (customType) text = customUnits.find((item) => item.id === customType)?.label || ''
  if (!text) text = getProgressTypeLabel(progressType)
  return text || progressType
}

export const getCustomUnitShortTextById = (id?: string) => {
  const unit = customUnits.find((item) => item.id === id)
  if (!unit) return id
  return unit.text
}

export const getActivityType = (goal: GoalWithProgress) => {
  const { progressType, customType, customName } = goal
  const isCustom = isCustomType(progressType)
  if (isCustom) {
    if (customType === CustomType.CUSTOM) {
      return customName
    } else {
      return getCustomTypeText(customType)
    }
  } else {
    return getProgressTypeLabel(progressType)
  }
}

export const getCustomTypeWithLegacy = (customType: CustomType | null, progressType: ProgressType) => {
  if (customType) return customType
  switch (progressType) {
    case ProgressType.ALL:
    case ProgressType.PERSISTENCE_ALL:
    case ProgressType.STEPS:
    case ProgressType.PERSISTENCE_STEPS:
    case ProgressType.COLLECTIVE_STEPS:
      return CustomType.STEPS
    case ProgressType.CALORIES:
    case ProgressType.PERSISTENCE_CALORIES:
    case ProgressType.COLLECTIVE_CALORIES:
      return CustomType.CALORIES
    case ProgressType.INTENSIVE_MINUTES:
    case ProgressType.PERSISTENCE_INTENSIVE_MINUTES:
    case ProgressType.COLLECTIVE_INTENSIVE_MINUTES:
      return CustomType.INTENSIVE_MINUTES
  }
  return null
}
